/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentProtocolEnum } from './VoiceAgentProtocolEnum';
import {
  VoiceAgentProtocolEnumFromJSON,
  VoiceAgentProtocolEnumFromJSONTyped,
  VoiceAgentProtocolEnumToJSON,
} from './VoiceAgentProtocolEnum';

/**
 *
 * @export
 * @interface VoiceAgentInferencerCelinaCreate
 */
export interface VoiceAgentInferencerCelinaCreate {
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCelinaCreate
   */
  name: string;
  /**
   *
   * @type {VoiceAgentProtocolEnum}
   * @memberof VoiceAgentInferencerCelinaCreate
   */
  protocol: VoiceAgentProtocolEnum;
  /**
   *
   * @type {Date}
   * @memberof VoiceAgentInferencerCelinaCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCelinaCreate
   */
  environment: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCelinaCreate
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCelinaCreate
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCelinaCreate
   */
  domain?: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCelinaCreate
   */
  voice?: string;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerCelinaCreate
   */
  maxDuration?: number;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerCelinaCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the VoiceAgentInferencerCelinaCreate interface.
 */
export function instanceOfVoiceAgentInferencerCelinaCreate(value: object): value is VoiceAgentInferencerCelinaCreate {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('environment' in value) || value['environment'] === undefined) return false;
  if (!('tenant' in value) || value['tenant'] === undefined) return false;
  return true;
}

export function VoiceAgentInferencerCelinaCreateFromJSON(json: any): VoiceAgentInferencerCelinaCreate {
  return VoiceAgentInferencerCelinaCreateFromJSONTyped(json, false);
}

export function VoiceAgentInferencerCelinaCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentInferencerCelinaCreate {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    protocol: VoiceAgentProtocolEnumFromJSON(json['protocol']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    environment: json['environment'],
    tenant: json['tenant'],
    region: json['region'] == null ? undefined : json['region'],
    domain: json['domain'] == null ? undefined : json['domain'],
    voice: json['voice'] == null ? undefined : json['voice'],
    maxDuration: json['max_duration'] == null ? undefined : json['max_duration'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function VoiceAgentInferencerCelinaCreateToJSON(value?: VoiceAgentInferencerCelinaCreate | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: VoiceAgentProtocolEnumToJSON(value['protocol']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    environment: value['environment'],
    tenant: value['tenant'],
    region: value['region'],
    domain: value['domain'],
    voice: value['voice'],
    max_duration: value['maxDuration'],
    credential_id: value['credentialId'],
  };
}
